module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Empresa-Logotipo-1.9ba83c2b.png";